import { KeyConstructor } from './keyConstructor';
const NETWORK_KEY = 'network';
const NEW_DOMAIN_STATUS_KEY = 'newDomainStatus';
const NETWORKS_KEY = 'networks';
export const getGlobalNetworkKey = KeyConstructor(NETWORK_KEY);
export const getNetworkKey = KeyConstructor(NETWORK_KEY);
export const getNewDomainStatusKey = KeyConstructor(NEW_DOMAIN_STATUS_KEY);
export const getNetworksKey = KeyConstructor(NETWORKS_KEY);
//# sourceMappingURL=network.key.js.map